import { all, call, spawn } from 'redux-saga/effects';

import {
  saveNewPlanGroup,
  updatePlanGroup,
  deletePlanGroup
} from './planGroupsSagas';

import {
  fetchPlanUnits,
  fetchPlanGroups,
  handlePreferences,
  setPreference, //  fetchDutyCodes,
  //  fetchDutyHourTypes,
  fetchHolidays,
  fetchWorkAgreements
} from './commonSagas';

export default function* rootSaga() {
  const sagas = [
    fetchPlanUnits,
    fetchPlanGroups,
    saveNewPlanGroup,
    updatePlanGroup,
    deletePlanGroup,
    handlePreferences,
    setPreference,
    //    fetchDutyCodes,
    //    fetchDutyHourTypes,
    fetchHolidays,
    fetchWorkAgreements
  ];
  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        try {
          yield call(saga);
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          // store this error in a service
        }
      })
    )
  );
}
